module.exports = __webpack_public_path__ + "img/a.e50dfc0e.svg";